import { render, staticRenderFns } from "./bar-chart.vue?vue&type=template&id=5ef4f27c&scoped=true&"
import script from "./bar-chart.vue?vue&type=script&lang=ts&"
export * from "./bar-chart.vue?vue&type=script&lang=ts&"
import style0 from "./bar-chart.vue?vue&type=style&index=0&id=5ef4f27c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef4f27c",
  null
  
)

export default component.exports